import React, { useState } from "react";
import logoImage from "../logo.png";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import { Link } from "react-router-dom";

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return (
    <header className="fixed top-0 left-0 right-0 backdrop-blur-xl border-slate-200 z-50 shadow-sm bg-[#13232eab]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/">
            <img src={logoImage} alt="YB Capital" className="h-14" />{" "}
          </Link>

          <nav className="hidden lg:flex items-center gap-10 uppercase">
            <a
              href="#home"
              className="text-white/60 hover:text-white/100 transition-all text-base font-light"
            >
              Home
            </a>
            <a
              href="#about"
              className="text-white/60 hover:text-white/100 transition-all text-base font-light"
            >
              About Us
            </a>

            <a
              href="#services"
              className="text-white/70 hover:text-white/100 transition-all text-base font-light"
            >
              Services
            </a>

            <a
              href="#approach"
              className="text-white/70 hover:text-white/100 transition-all text-base font-light"
            >
              Approach
            </a>
            <a
              href="#careers"
              className="text-white/70 hover:text-white/100 transition-all text-base font-light"
            >
              Careers
            </a>
            <a
              href="#contact"
              className="text-white/70 hover:text-white/100 transition-all text-base font-light"
            >
              Contact
            </a>
          </nav>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden"
          >
            {mobileMenuOpen ? <p>open</p> : <p>cloded</p>}
            {/* mobileMenuOpen ? <CloseIcon className="w-6 h-6" /> : <MenuIcon className="w-6 h-6" /> */}
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-slate-200 px-6 py-4">
          <nav className="flex flex-col gap-4">
            <a
              href="#solutions"
              className="text-slate-700 hover:text-[#1e3a8a] py-2"
            >
              Home
            </a>
            <a
              href="#platform"
              className="text-slate-700 hover:text-[#1e3a8a] py-2"
            >
              About Us
            </a>
            <a
              href="#pricing"
              className="text-slate-700 hover:text-[#1e3a8a] py-2"
            >
              Service
            </a>
            <a
              href="#resources"
              className="text-slate-700 hover:text-[#1e3a8a] py-2"
            >
              Contact Us
            </a>
            <div className="flex flex-col gap-2 pt-4 border-t border-slate-200">
              <button className="text-slate-700 px-5 py-2.5 text-left">
                Sign In
              </button>
              <button className="bg-gradient-to-r from-[#1e3a8a] to-[#0ea5e9] text-white px-6 py-2.5 rounded-full">
                Get Started
              </button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
